(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3ugc"] && !Shopify.designMode) return;
  try {
    
  if (!window.mountOvssUgc) {
    window.mountOvssUgc = function (scope) {
      scope.querySelectorAll('[data-ovss-ugc]').forEach(function (root) {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        var track = root.querySelector('[data-ugc-track]');
        var cards = Array.from(root.querySelectorAll('[data-ugc-card]'));
        var previous = root.querySelector('[data-ugc-previous]');
        var next = root.querySelector('[data-ugc-next]');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var autoplay = root.dataset.autoplay === 'true' && !reducedMotion;
        var visible = false;
        var activeIndex = 0;
        var frame = null;
        if (!track || cards.length === 0) return;

        function load(video) {
          if (!video || video.dataset.loaded === 'true') return;
          var source = video.dataset.src;
          if (!source) return;
          video.src = source;
          video.dataset.loaded = 'true';
        }

        function updateControls(card, video) {
          var toggle = card.querySelector('[data-ugc-toggle]');
          var sound = card.querySelector('[data-ugc-sound]');
          card.classList.toggle('is-paused', Boolean(video && video.paused));
          if (toggle) toggle.setAttribute('aria-label', video && video.paused ? root.dataset.labelPlay : root.dataset.labelPause);
          if (sound) {
            sound.classList.toggle('is-on', Boolean(video && !video.muted));
            sound.setAttribute('aria-label', video && !video.muted ? root.dataset.labelMute : root.dataset.labelUnmute);
          }
        }

        function pauseOthers(activeVideo) {
          cards.forEach(function (card) {
            var video = card.querySelector('[data-ugc-video]');
            if (video && video !== activeVideo) {
              video.pause();
              video.muted = true;
              updateControls(card, video);
            }
          });
        }

        function activate(index, shouldPlay) {
          activeIndex = Math.max(0, Math.min(index, cards.length - 1));
          cards.forEach(function (card, cardIndex) {
            card.classList.toggle('is-active', cardIndex === activeIndex);
          });
          var activeCard = cards[activeIndex];
          var activeVideo = activeCard.querySelector('[data-ugc-video]');
          pauseOthers(activeVideo);
          if (activeVideo) {
            load(activeVideo);
            if (visible && shouldPlay && autoplay) {
              var promise = activeVideo.play();
              if (promise && promise.catch) promise.catch(function () {});
            }
            updateControls(activeCard, activeVideo);
          }
        }

        function closestCard() {
          var trackRect = track.getBoundingClientRect();
          var center = trackRect.left + trackRect.width / 2;
          var closest = 0;
          var distance = Infinity;
          cards.forEach(function (card, index) {
            var rect = card.getBoundingClientRect();
            var currentDistance = Math.abs(rect.left + rect.width / 2 - center);
            if (currentDistance < distance) {
              distance = currentDistance;
              closest = index;
            }
          });
          return closest;
        }

        function onScroll() {
          if (frame) return;
          frame = requestAnimationFrame(function () {
            frame = null;
            var index = closestCard();
            if (index !== activeIndex) activate(index, true);
          });
        }

        function go(index) {
          var target = cards[Math.max(0, Math.min(index, cards.length - 1))];
          if (!target) return;
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }

        cards.forEach(function (card, index) {
          var video = card.querySelector('[data-ugc-video]');
          var toggle = card.querySelector('[data-ugc-toggle]');
          var sound = card.querySelector('[data-ugc-sound]');
          if (toggle && video) {
            toggle.addEventListener('click', function () {
              if (index !== activeIndex) {
                activate(index, true);
                go(index);
                return;
              }
              load(video);
              if (video.paused) {
                pauseOthers(video);
                var promise = video.play();
                if (promise && promise.catch) promise.catch(function () {});
              } else {
                video.pause();
              }
              updateControls(card, video);
            });
            video.addEventListener('play', function () { updateControls(card, video); });
            video.addEventListener('pause', function () { updateControls(card, video); });
          }
          if (sound && video) {
            sound.addEventListener('click', function () {
              load(video);
              pauseOthers(video);
              video.muted = !video.muted;
              if (!video.muted && video.paused) {
                var promise = video.play();
                if (promise && promise.catch) promise.catch(function () {});
              }
              updateControls(card, video);
            });
          }
        });

        if (previous) previous.addEventListener('click', function () { go(activeIndex - 1); });
        if (next) next.addEventListener('click', function () { go(activeIndex + 1); });
        track.addEventListener('scroll', onScroll, { passive: true });

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            visible = Boolean(entries[0] && entries[0].isIntersecting);
            if (visible) activate(activeIndex, true);
            else pauseOthers(null);
          }, { threshold: .3 });
          observer.observe(root);
        } else {
          visible = true;
        }

        activate(0, true);
      });
    };
    document.addEventListener('shopify:section:load', function (event) {
      window.mountOvssUgc(event.target);
    });
  }
  window.mountOvssUgc(document);

  } catch(e) { console.error(e); }
})();
})();
